import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Link, Navigate, Route, Routes } from "react-router-dom";
import * as React from 'react';
import { IApiClient, ApiClient } from './http_client/api_client';
import { apiConfigurationDefault, TApiConfiguration } from './http_client/api_configuration';
import { getConfEnte, getCookie, inviaDatiPost } from './mixin/functions';
import { TApiResponse, TAppProps, TAppState, TBreadcrumb, TConfEnteDati } from './mixin/types';
import AppProvider from './mixin/app_provider';
import { Breadcrumb, BreadcrumbItem, Col, Container, Feedback, Footer, FullHeader, Loader, Row, IntegrationFooter, IntegrationHeader, TabMenu, Badge } from 'deda-rkit';


//Mapping delle route del Portal
const Index = React.lazy(() => import('./views/index'));
const AutenticazioneFallita = React.lazy(() => import('./views/autenticazione_fallita'));
const ImpostazioniNotifiche = React.lazy(() => import('./views/impostazioni_notifiche'));
const NotifichePersonali = React.lazy(() => import('./views/notifiche_personali'));
const InformativaGdpr = React.lazy(() => import('./views/informativa_gdpr'));
const Autenticazione = React.lazy(() => import('./views/autenticazione'));
const SchedaInformativa = React.lazy(() => import('./views/scheda_informativa'));
const SchedeInformative = React.lazy(() => import('./views/schede_informative'));
const GuideTecniche = React.lazy(() => import('./views/guide_tecniche'));
const GuidaTecnica = React.lazy(() => import('./views/guida_tecnica'));
const DettagliUtente = React.lazy(() => import('./views/dettagli_utente'));
const TrattamentoDati = React.lazy(() => import('./views/trattamento_dati'));
const ModificaDatiUtente = React.lazy(() => import('./views/modifica_dati_utente'));
const ModificaPassword = React.lazy(() => import('./views/modifica_password'));
const Registrazione = React.lazy(() => import('./views/registrazione'));
const GestisciServizi = React.lazy(() => import('./views/gestisci_servizi'));
const TuttiIservizi = React.lazy(() => import('./views/tutti_iservizi'));
const UsernameDimenticato = React.lazy(() => import('./views/username_dimenticato'));
const PasswordDimenticata = React.lazy(() => import('./views/password_dimenticata'));
const ControlloContatti = React.lazy(() => import('./views/controllo_contatti'));
const CodiceAutenticazione = React.lazy(() => import('./views/codice_autenticazione'));
const Logout = React.lazy(() => import('./views/logout'));

/* Elenco dei componenti */
// const BoxGuideTecniche = React.lazy(() => import('./components/box_guide_tecniche'));
// const FlashAlert = React.lazy(() => import('./components/flashAlert'));
// const ScrollTopButton = React.lazy(() => import('./components/scrollTopButton'));
// const ErrorBoundary = React.lazy(() => import('./components/errorBoundary'));

/* Importo i vari componenti nel bundle generale perchè tanto non li parallellizza */
import BoxGuideTecniche from './components/box_guide_tecniche';
import FlashAlert from './components/flashAlert';
import ScrollTopButton from './components/scrollTopButton';
import ErrorBoundary from './components/errorBoundary';
import { ScrollTopWrapper } from './components/scrollTopWrapper';
import { initTrackerMatomo, trackMatomo } from './mixin/tracker';


//fine Portal
/* Fine elenco dei componenti */


class App extends React.Component<TAppProps, TAppState> {

  apiClient: IApiClient;
  apiConfiguration: TApiConfiguration;

  // Provider in your app
  public defaultState: TAppState = {
    scene: {},
    routes: [],
    breadcrumb: [{ label: 'Home', url: '/' }],
    loader: { visible: false },
    context: null, /* all'inizio null, carico il contesto con getConfEnte nel componentDidMount*/
    flash: null,
    elemChanged: null
  }

  constructor(props) {
    super(props);
    this.apiConfiguration = apiConfigurationDefault; /* uso quella di default */
    this.state = this.defaultState;
    this.apiClient = new ApiClient(this.apiConfiguration);
    this.handleUpdateBreadcrumb = this.handleUpdateBreadcrumb.bind(this);
    this.handleUpdateLoader = this.handleUpdateLoader.bind(this);
    //this.routeWithSubRoutes = this.routeWithSubRoutes.bind(this);
    this.setNewContext = this.setNewContext.bind(this);
  }

  /* Metodo che aggiorna lo state.breadcrumb che viene usata per visualizzare le breadcrumb */
  handleUpdateBreadcrumb = (breadcrumbNested: TBreadcrumb | TBreadcrumb[] | null) => {
    let arrayBreadInit = [{ label: 'Home', url: '/portal' }];

    //url home caso portal integrato con sito comunale
    if(this.state?.context?.confEnte.url_sito && this.state?.context?.confEnte.external_header){
      arrayBreadInit = [{ label: 'Home', url: this.state.context.confEnte.url_sito }];
    }
    
    if (breadcrumbNested === null) {
      this.setState(() => ({ breadcrumb: arrayBreadInit }));
    } else {
      // controllo breadcrumb 'Servizi' caso portal integrato sito comunale
      if(this.state?.context?.confEnte.url_sito && this.state?.context?.confEnte.external_header){
        if (Array.isArray(breadcrumbNested)) {
          breadcrumbNested = breadcrumbNested.map(element => {
            if (element.label === 'Servizi') {
              const urlSito = this.state.context.confEnte.url_sito
              const urlCompleto = urlSito + ((urlSito.at(-1) === '/')? '' : '/') + 'servizi';
              element.url = urlCompleto;
            }
            return element
          })
        }
      }
      /* se passo un oggetto lo inserisco in un array, altrimenti fa merge di array vuoto con breadcrumbNested */
      breadcrumbNested = [].concat(breadcrumbNested);
      this.setState({ breadcrumb: [...arrayBreadInit, ...breadcrumbNested] });
      //this.setState(prevState => ({breadcrumb: [...prevState['breadcrumb'],breadcrumbNested]}));
    }

  }

  /* Metodo che aggiorna lo state.loader che viene usata per visualizzare del loader */
  handleUpdateLoader = (visibility: boolean) => {
    //document.querySelector('#cont_header').classList.remove("hide");
    if(visibility == false){
      this.setState({ loader: { visible: visibility },elemChanged: true });
    }else{
      this.setState({ loader: { visible: visibility } });
    }
    /* questo if toglie l'utilizzo del loader modale per avere migliori prestazioni */
    // if(visibility == false){
    //   this.setState({elemChanged: true });
    // }
  }

  // Method to update context: newContext.appName contiene il nome dell'app
  setNewContext = (newContext) => {
    // console.log("NUOVO CONTEXT");
    // console.log(newContext);
    this.setState(prevState => ({ context: { ...prevState.context, ...newContext } }));
  }

  // Questa funzione aggiunge l'elemento badge per i link Notifiche e Comunicazioni se ce ne sono da leggere
  aggiungiElementoBageHeaderLinks = (headerLinks , notificheDaLeggere, comunicazioniDaLeggere) => {
    return headerLinks.map((link) => {

      // Se è presente una chiave id in configurazione per questo header links, fornisco l'elemento con il badge degli elementi ancora da leggere
      if (link.id) {
        if (link.id == 'notifiche' && notificheDaLeggere > 0) {

          link.element = <>{link.label}<Badge className='bg-light mx-1 text-primary' >{ notificheDaLeggere }</Badge></>
        }
        if (link.id == 'comunicazioni' && comunicazioniDaLeggere > 0) {
          link.element = <>{link.label}<Badge className='bg-light mx-1 text-primary' >{ comunicazioniDaLeggere }</Badge></>
        }
      }
      return link
    })
  }

  // Si aziona al cambio di focus sulla tab, controlla lo stato della sessione a backend
  onfocusTabHandler = async (ev) => {
    let response: TApiResponse;
    response = await inviaDatiPost(this.apiClient,location.origin + '/portal/user_logged',{fec: getCookie('fec')}, this.handleUpdateLoader, this.setNewContext);
    
    if (response?.loggato === "si" && this.state.context?.userLogged) {

      const context = this.state.context;

      context.notifiche_utente_non_lette = response.notifiche_non_lette;
      context.comunicazioni_utente_non_lette = response.comunicazioni_non_lette;

      context.confEnte.header_links = this.aggiungiElementoBageHeaderLinks(context.confEnte.header_links, context.notifiche_utente_non_lette,  context.comunicazioni_utente_non_lette)

      this.setState({ context })

    }

    // nel caso in cui lo stato della sessione utente FE deve essere aggiornato rispetto al BE
    // effettuiamo una chiamata confEnte
    if ((response && response.loggato === "si" && this.state.context && !this.state.context.userLogged) 
          ||
        (response && response.loggato === "no" && this.state.context && this.state.context.userLogged)) {
      
      const configEnte: TApiResponse = await getConfEnte(this.apiClient);

      if (configEnte != null && configEnte.esito === 'ok') {

        const datiConf: TConfEnteDati = configEnte.dati;

        /* carico i dati dell'ente nel context nello state */
        this.setState({ context: { confEnte: datiConf, userLogged: datiConf.utente_loggato }, flash: configEnte.flash })
       
        return

      }else{
        console.error("Errore nel recupero dei dati di confEnte");
                
      }

    }

    return
  }
  

  async componentDidMount() {
      
    let routes: any[] = [];


    const configEnte: TApiResponse = await getConfEnte(this.apiClient);

    if (configEnte != null && configEnte.esito === 'ok') {

      const datiConf: TConfEnteDati = configEnte.dati;

      // Inizializzazione script matomo in pagina, proveninte da Web Analytics italia ( primo elemento dei tracker)
      if ( datiConf.tracking_site_id ) {
        initTrackerMatomo(datiConf.trackers);
      }


      console.log("conf ente ");
      console.log(datiConf);

      if (datiConf.utente_loggato ) {
        
        let response: TApiResponse;
        response = await inviaDatiPost(this.apiClient, location.origin + '/portal/user_logged', { fec: getCookie('fec') }, this.handleUpdateLoader, this.setNewContext);
        
        let notifiche_utente_non_lette;
        let comunicazioni_utente_non_lette;
        
        if (response?.loggato === "si" ) {
  
          notifiche_utente_non_lette = response.notifiche_non_lette;
          comunicazioni_utente_non_lette = response.comunicazioni_non_lette;
  
          if (notifiche_utente_non_lette || comunicazioni_utente_non_lette) {
            datiConf.header_links = this.aggiungiElementoBageHeaderLinks(datiConf.header_links, notifiche_utente_non_lette,  comunicazioni_utente_non_lette)
          }
        }
  
      }


      /* carico i dati dell'ente nel context nello state */
      this.setState({ context: { confEnte: datiConf, userLogged: datiConf.utente_loggato, tabMenuAutenticatoVisibile: true }, flash: configEnte.flash, routes: routes });


        if (datiConf.apps.includes('moduli')) {
          const pathModuli: string = "/portal/servizi/moduli";
          try {
            const IndexModuli = React.lazy(() => import(`Init/moduli/fe_react/src/views/index_moduli`));
            const PreAuthModuli = React.lazy(() => import(`Init/moduli/fe_react/src/views/pre_auth`));
            const PrivacyModulo = React.lazy(() => import(`Init/moduli/fe_react/src/views/privacy_modulo`));
            const DatiUtente = React.lazy(() => import(`Init/moduli/fe_react/src/views/dati_utente`));
            const Modulo = React.lazy(() => import(`Init/moduli/fe_react/src/views/modulo`));
            const AssociaBlocchiRipetitivi = React.lazy(() => import(`Init/moduli/fe_react/src/views/associa_blocchi_ripetitivi`));
            const PagamentiIstanza = React.lazy(() => import(`Init/moduli/fe_react/src/views/pagamenti_istanza`));
            const RiepilogoIstanza = React.lazy(() => import(`Init/moduli/fe_react/src/views/riepilogo_istanza`));
            const PagamentoModulo = React.lazy(() => import(`Init/moduli/fe_react/src/views/pagamento_modulo`));
            //Creo la route per la cancellazione
            const EliminaModulo = React.lazy(() => import(`Init/moduli/fe_react/src/views/elimina_modulo`));
            
            const ElencoBuoni = React.lazy(() => import(`Init/moduli/fe_react/src/views/elenco_buoni`));
            const VerificaBuonoSpesa = React.lazy(() => import(`Init/moduli/fe_react/src/views/verifica_buono_spesa`));

            const BandiScadutiChiusi = React.lazy(() => import(`Init/moduli/fe_react/src/views/bandi_scaduti_chiusi`));
            const BandiScadutiInCorso = React.lazy(() => import(`Init/moduli/fe_react/src/views/bandi_scaduti_in_corso`));

            // root per concessioni
            const RicercaConcessioni = React.lazy(() => import(`Init/moduli/fe_react/src/views/ricerca_concessioni`));
            // root per contributi
            const RicercaContribuenti = React.lazy(() => import(`Init/moduli/fe_react/src/views/ricerca_contribuenti`));

            routes = routes.concat([
              {
                path: `${pathModuli}`,
                component: IndexModuli
              },
              {
                path: `${pathModuli}/pre_auth`,
                component: PreAuthModuli
              },
              {
                path: `${pathModuli}/:tipo/modulo`,
                component: Modulo,
                protected: true
              },
              {
                path: `${pathModuli}/:idmodulo/associa_blocchi_ripetitivi`,
                component: AssociaBlocchiRipetitivi,
                protected: true
              },
              {
                path: `${pathModuli}/:idmodulo/pagamenti_istanza`,
                component: PagamentiIstanza,
                protected: true
              },
              {
                path: `${pathModuli}/:idmodulo/riepilogo_istanza`,
                component: RiepilogoIstanza,
                protected: true
              },
              {
                path: `${pathModuli}/:id/cancella`,
                component: EliminaModulo,
                protected: true
              },
              //Buoni spesa
              {
                path: `${pathModuli}/buoni_spesa/elenco_buoni`,
                component: ElencoBuoni,
                protected: true
              },
              {
                path: `${pathModuli}/buoni_spesa/verifica_buono_spesa`,
                component: VerificaBuonoSpesa,
                protected: true
              },
              {
                path: `${pathModuli}/buoni_spesa/`,
                component: VerificaBuonoSpesa,
                protected: true
              },
              //Bandi
              {
                path: `${pathModuli}/bandi_scaduti_chiusi`,
                component: BandiScadutiChiusi
              },
              {
                path: `${pathModuli}/bandi_scaduti_in_corso`,
                component: BandiScadutiInCorso
              },
              //
              {
                path: `${pathModuli}/:tipo/privacy_modulo/:id?`,
                component: PrivacyModulo,
                protected: true
              },
              {
                path: `${pathModuli}/:tipo/dati_utente/:id?`,
                component: DatiUtente,
                protected: true
              },
              {
                path: `${pathModuli}/:tipo/modulo/:id`,
                component: Modulo,
                protected: true
              },
              //Concessioni
              {
                path: `${pathModuli}/concessioni/`,
                component: RicercaConcessioni,
                protected: true
              },
              {
                path: `/portal/servizi/concessioni/`,
                component: RicercaConcessioni,
                protected: true
              },
              //Contributi
              {
                path: `${pathModuli}/contributi/`,
                component: RicercaContribuenti,
                protected: true
              },
              {
                path: `/portal/servizi/contributi/`,
                component: RicercaContribuenti,
                protected: true
              },
              {
                path: `${pathModuli}/:id/pagamento_modulo/`,
                component: PagamentoModulo,
                protected: true
              }
            ]
            );
          }
          catch (e) {
            console.log("Moduli non presente");
          }
        }

        if (datiConf.apps.includes('muse')) {

          const pathMuse: string = "/portal/servizi/muse";
          try {

            const IndexMuse = React.lazy(() => import(`Init/muse/fe_react/src/views/index_muse`));
            const PreAuthMuse = React.lazy(() => import(`Init/muse/fe_react/src/views/pre_auth`));
            const DettaglioPuntoErogazione = React.lazy(() => import(`Init/muse/fe_react/src/views/dettaglio_punto_erogazione`));
            const Consuntiva = React.lazy(() => import(`Init/muse/fe_react/src/views/consuntiva`));
            const Carta = React.lazy(() => import(`Init/muse/fe_react/src/views/carta`));
            const ElencoIscrizioni = React.lazy(() => import(`Init/muse/fe_react/src/views/elenco_iscrizioni`));
            const MuseIscrizione = React.lazy(() => import(`Init/muse/fe_react/src/views/muse_iscrizione`));
            const ElencoIsee = React.lazy(() => import(`Init/muse/fe_react/src/views/elenco_isee`));
            const CaricaIsee = React.lazy(() => import(`Init/muse/fe_react/src/views/carica_isee`));
            const IscrizioneEseguita = React.lazy(() => import(`Init/muse/fe_react/src/views/iscrizione_eseguita`));
            const MusePresenze = React.lazy(() => import(`Init/muse/fe_react/src/views/muse_presenze`));
            const ConfigurazioneFiglio = React.lazy(() => import(`Init/muse/fe_react/src/views/configurazione_figli`));

            routes = routes.concat([
              {
                path: `${pathMuse}/iscrizione/:id/vedi_iscrizione`,
                component: MuseIscrizione,
                protected: true
              },
              {
                path: `${pathMuse}/iscrizione/elenco_iscrizioni`,
                component: ElencoIscrizioni,
                protected: true
              },
              {
                path: `${pathMuse}/iscrizione/carica_isee`,
                component: CaricaIsee,
                protected: true
              },
              {
                path: `${pathMuse}/iscrizione/elenco_isee`,
                component: ElencoIsee,
                protected: true
              },
              {
                path: `${pathMuse}/iscrizione/:id/iscrizione_eseguita`,
                component: IscrizioneEseguita,
                protected: true
              },
              {
                path: `${pathMuse}/iscrizione`,
                component: MuseIscrizione,
                protected: true
              },
              {
                path: `${pathMuse}/presenze`,
                component: MusePresenze,
                protected: true
              },
              {
                path: `${pathMuse}/consuntiva/:id`,
                component: Consuntiva,
                protected: true
              },
              {
                path: `${pathMuse}/carte/:id`,
                component: Carta,
                protected: true
              },
              {
                path: `${pathMuse}/configurazione_figli`,
                component: ConfigurazioneFiglio
              },
              {
                path: `${pathMuse}`,
                component: IndexMuse
              }
            ]);

            if(datiConf.musenext){
              routes = routes.concat([
              {
                path: `${pathMuse}/pre_auth`,
                component: PreAuthMuse,
                protected: false
              },
              {
                path: `${pathMuse}/dettaglio_punto_erogazione/:id`,
                component: DettaglioPuntoErogazione,
                protected: false
              }
              ]);
            }


          }
          catch (e) {
            console.log("Muse non presente");
          }
        }

        if (datiConf.apps.includes('pagamenti')) {
            const pathPagamenti: string = "/portal/servizi/pagamenti";
            try {
              const Carrello = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/carrello`));
              // const PagamentiSpontanei = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/pagamenti_spontanei`));
              // const PagamentoSpontaneo = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/pagamento_spontaneo`));
              const PagamentiPreAuth = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/pre_auth`));
              const PagamentiOnLine = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/pagamenti_online`));
              const HelpCarrello = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/help_carrello`));
              const RiepilogoPagoPa = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/riepilogo_pagopa_checkout`));
              const PagamentoOnLine = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/nuovo_pagamento_online`));
              const ModelloOnLine = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/nuovo_pagamento_online`));
              const StoricoPagamenti = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/storico_pagamenti`));
              const ElencoTransazioni = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/elenco_transazioni`));
              const CercaIuv = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/cerca_iuv`));
              const AttesaPagamento = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/attesa_pagamento`));
              const PagaPerAltri = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/paga_per_altri`));
              const GestioneAvviso = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/gestione_avviso`));
              const RecuperaAvviso = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/recupera_avviso`));
              const PrivacyTipoDovuto = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/privacy_tipo_dovuto`));
              const DatiUtenteTipoDovuto = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/dati_utente_tipo_dovuto`));
              const CarrelloTipoDovuto = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/carrello_tipo_dovuto`));
              const RiepilogoTipoDovuto = React.lazy(() => import(`Init/pagamenti/fe_react/src/views/riepilogo_tipo_dovuto`));

              routes = routes.concat([
                {
                  path: `${pathPagamenti}/pagopa/riepilogo_pagopa_checkout`,
                  component: RiepilogoPagoPa,
                  protected: true
                },
                {
                  path: `${pathPagamenti}/pagopa/attesa_pagamento`,
                  component: AttesaPagamento
                },
                {
                  path: `${pathPagamenti}/gestione_avviso`,
                  component: GestioneAvviso
                },
                {
                  path: `${pathPagamenti}/recupera_avviso/:key`,
                  component: RecuperaAvviso
                },
                {
                  path: `${pathPagamenti}/elenco_transazioni`,
                  component: ElencoTransazioni,
                  protected: true
                },
                {
                  path: `${pathPagamenti}/storico_pagamenti`,
                  component: StoricoPagamenti,
                  protected: true
                },
                {
                  path: `${pathPagamenti}/paga_per_altri`,
                  component: PagaPerAltri,
                  protected: true
                },
                {
                  path: `${pathPagamenti}/cerca_iuv`,
                  component: CercaIuv,
                  protected: true
                },
                {
                  path: `${pathPagamenti}/pre_auth`,
                  component: PagamentiPreAuth
                },
                {
                  path: `${pathPagamenti}/pagamenti_online`,
                  component: PagamentiOnLine,
                },
                {
                  path: `${pathPagamenti}/help`,
                  component: HelpCarrello,
                  protected: true
                },
                {
                  path: `${pathPagamenti}/nuovo_pagamento_online/:id`,
                  component: PagamentoOnLine
                },
                {
                  path: `${pathPagamenti}/nuovo_modello_online/:id`,
                  component: ModelloOnLine
                },
                {
                  path: `${pathPagamenti}/aggiungi_pagamento_pagopa/`,
                  component: Carrello,
                  protected: true
                },
                {
                  path: `${pathPagamenti}/:id/privacy_tipo_dovuto/`,
                  component: PrivacyTipoDovuto,
                  protected: true
                },
                {
                  path: `${pathPagamenti}/:id/dati_utente_tipo_dovuto/`,
                  component: DatiUtenteTipoDovuto,
                  protected: true
                },
                {
                  path: `${pathPagamenti}/:id/carrello_tipo_dovuto/`,
                  component: CarrelloTipoDovuto,
                  protected: true
                },
                {
                  path: `${pathPagamenti}/:id/riepilogo_tipo_dovuto/`,
                  component: RiepilogoTipoDovuto,
                  protected: true
                },
                {
                  path: `${pathPagamenti}/carrello`,
                  component: Carrello,
                  protected: true
                },
                {
                  path: `${pathPagamenti}/`,
                  component: Carrello
                }
              ]
              );
            }
            catch (e) {
              console.log("Pagamenti non presente");
            }
        }
    

        if (datiConf.apps.includes('comunicazioni')) {

            const pathComunicazioni: string = "/portal/servizi/comunicazioni";
            try {
              const IndexComunicazioni = React.lazy(() => import(`Init/comunicazioni/fe_react/src/views/index_comunicazioni`));
              const DettaglioComunicazione = React.lazy(() => import(`Init/comunicazioni/fe_react/src/views/dettaglio_comunicazione`));
              const ArchivioComunicazioni = React.lazy(() => import(`Init/comunicazioni/fe_react/src/views/archivio_comunicazioni`));

              routes = routes.concat([
                {
                  path: `${pathComunicazioni}/elenco_privato`,
                  component: IndexComunicazioni,
                  protected: true
                },
                {
                  path: `${pathComunicazioni}/dettaglio/:id`,
                  component: DettaglioComunicazione
                },
                {
                  path: `${pathComunicazioni}/archivio`,
                  component: ArchivioComunicazioni
                },
                {
                  path: pathComunicazioni,
                  component: IndexComunicazioni
                }]
              );
            }
            catch (e) {
              console.log("Comunicazioni non presente");
            }
    
        }

        /* Route di Portal */
        routes = routes.concat([
          {
            path: "/portal/autenticazione_fallita",
            component: AutenticazioneFallita,
            protected: false
          },
          {
            path: "/portal/notifiche/impostazioni",
            component: ImpostazioniNotifiche,
            protected: true
          },
          {
            path: "/portal/notifiche/",
            component: NotifichePersonali,
            protected: true
          },
          {
            path: "/portal/tutti_i_servizi",
            component: TuttiIservizi,
          },
          {
            path: "/portal/informativa_gdpr",
            component: InformativaGdpr,
          },
          {
            path: "/portal/registrazione",
            component: Registrazione
          },
          {
            path: "/portal/autenticazione/login",
            component: Autenticazione
          },
          {
            path: "/portal/autenticazione/logout",
            component: Logout
          },
          {
            path: "/portal/autenticazione",
            component: Autenticazione
          },
          {
            path: "/portal/codice_autenticazione",
            component: CodiceAutenticazione
          },
          {
            path: "/portal/username_dimenticato",
            component: UsernameDimenticato
          },
          {
            path: "/portal/password_dimenticata",
            component: PasswordDimenticata
          },
          {
            path: "/portal/schede_informative/:id",
            component: SchedaInformativa,
          },
          {
            path: "/portal/schede_informative",
            component: SchedeInformative,
          },
          {
            path: "/portal/guide_tecniche/:id",
            component: GuidaTecnica,
          },
          {
            path: "/portal/guide_tecniche",
            component: GuideTecniche,
          },
          {
            path: "/portal/strutture",
            component: GuideTecniche,
          },
          {
            path: "/portal/controllo_cellulare",
            component: ControlloContatti,
          },
          {
            path: "/portal/controllo_email",
            component: ControlloContatti,
          },
          {
            path: "/portal/modifica_dati_utente",
            component: ModificaDatiUtente,
            protected: true
          },
          {
            path: "/portal/cambia_password",
            component: ModificaPassword,
            protected: true
          },
          {
            path: "/portal/dettagli_utente",
            component: DettagliUtente,
            protected: true
          },
          {
            path: "/portal/conferma_gdpr",
            component: TrattamentoDati,
            protected: true
          },
          {
            path: "/portal/servizi",
            component: GestisciServizi,
            protected: true
          },
          {
            path: "/portal",
            component: Index,
          },
          {
            path: "/index",
            component: Index,
          },
          {
            path: "/",
            component: Index,
          }
        ])

        console.info("routes totali");
        console.info(routes);

        this.setState({ routes: routes })

    } else {
      this.setState({ flash: configEnte.flash });
      console.error("Problemi nel caricamento delle configurazioni ente!");
    }
    document.addEventListener("visibilitychange",this.onfocusTabHandler);

  }


  ProtectedRoute = ({ userLogged, path, children }) => {
    if (!userLogged) {
      if ((location.pathname.replace(/^\/+|\/+$/g, '') !== "portal/autenticazione") ) {
        return <Navigate to={"/portal/autenticazione?redirect=" + window.location.pathname + window.location.search} replace />;
        /*return <Redirect
          to={{
            pathname: "/portal/autenticazione",
            search: "?redirect=" + window.location.pathname + window.location.search,
            state: { referrer: path }
          }}
        />*/
      }
    }

    return children;
  }

  async componentDidUpdate(prevProps: Readonly<TAppProps>, prevState: Readonly<TAppState>, snapshot?: any): Promise<void> {  
    if (prevState.context) {
      
      // Invio dati tracking matomo
      if (this.state.context?.confEnte?.tracking_site_id && !this.state.loader?.visible) {
        trackMatomo();
      }
      
      if (this.state.context?.userLogged) {
        let redirect = true;
        for (const route of this.state.routes) {
          if (route.path === window.location.pathname && route.protected ) {
            redirect = false;
            break
          }
        }
        if (!getCookie('fec') && redirect) {
          document.cookie = "fec=redirect;path=/"
          this.setNewContext({userLogged: false});
        }
      }
      
      //se l'utente in precedenza era loggato, e ci siamo accorti che adesso è scaduta la sessione, settiamo il flash e redirect
      if ((prevState.context.userLogged != this.state.context?.userLogged) && (prevState.context.userLogged == true)) {
        //se siamo già nella root autenticazione, non facciamo nulla
        
        if ((location.pathname.replace(/^\/+|\/+$/g, '') !== "portal/autenticazione") ) {
          let redirect = true;
          
          for (const route of this.state.routes) {
            //TODO ottimizzare
            //sostituiamo i numeri con carattere di comodo
            const pathCorrente = window.location.pathname.replace(/\d{1,}/g,":D");

            //sostituiamo i parametri con carattere di comodo
            const pathRoute = route.path.replace(/:(.*?)(\/|$)/g, ":D$2");

            if (pathRoute === pathCorrente && route.protected ) {
              redirect = false;
              break
            }
          }
          if (redirect) {
            const flash = {
              dangerMsg: "Sessione scaduta",
              targetPath: "/portal/autenticazione"
            }
            this.handleUpdateLoader(true);
            const response: TApiResponse = await this.apiClient.post("portal/setta_flash",flash);
            if (response.esito === "ok") {
              location.href = window.location.origin + "/portal/autenticazione?redirect=" + window.location.pathname + window.location.search
            }
          }
        }
       
      }
    } 
    
  }

  render() {

    return (
      <React.Fragment>
        {/* Uso il context per tutte le componenti innestate */}
        <AppProvider context={this.state.context}>
          <Router>
            <ScrollTopWrapper>
              <ScrollTopButton />
              {(this.state.context?.confEnte != null) && this.state.elemChanged && (
                <div id='cont_header' className=''>
                <ErrorBoundary>
                  <React.Suspense fallback={<span>Loading...</span>}>
                    {(this.state.context?.confEnte.external_footer != null && 
                      this.state.context?.confEnte.external_footer != '' &&
                      this.state.context?.confEnte.external_header != null &&
                      this.state.context?.confEnte.external_header != ''
                      )?
                      (<IntegrationHeader  user={
                          {
                            nome: (this.state.context.confEnte.utente_nome)? this.state.context.confEnte.utente_nome : '',
                            cognome: (this.state.context.confEnte.utente_cognome) ? this.state.context.confEnte.utente_cognome : ''
                          }
                        } userLogged = {this.state.context.userLogged}  
                        urlFetch={this.state.context.confEnte.external_header} baseUrl= {this.state.context.confEnte.base_url}
                        ></IntegrationHeader>)
                      :
                      (<FullHeader
                        sticky={this.state.context.confEnte.sticky_header}
                        stickyLogin={true}
                        user={
                          {
                            nome: (this.state.context.confEnte.utente_nome)? this.state.context.confEnte.utente_nome : '',
                            cognome: (this.state.context.confEnte.utente_cognome) ? this.state.context.confEnte.utente_cognome : ''
                          }
                        }
                        nomeEnte={this.state.context.confEnte.titolo_header}
                        stemma={this.state.context.confEnte.stemma ?? ''}
                        stemmaBurger={this.state.context.confEnte.stemma_burger ?? ''}
                        officialWebsite={this.state.context.confEnte.url_sito}
                        userLogged={this.state.context.userLogged}
                        headerLinks={this.state.context.confEnte.header_links}
                        navigazioneReact = {this.state.context.confEnte.navigazione_react ?? true}
                        baseUrl = {this.state.context.confEnte.base_url ?? ''}
                        regione = {this.state.context.confEnte.regione ?? ''}
                        regione_sito = {this.state.context.confEnte.regione_sito ?? ''}
                        classNameSticky='w-100'
                      />)

                    }
                  </React.Suspense>
                </ErrorBoundary>
                </div>
              )}
              <Container id='cont_principale' style={{minHeight:'800px'}}>
                <Row className='mt-3 mb-3'>
                  <Col>
                    <Breadcrumb>
                      {this.state.breadcrumb.length > 1 && (
                        this.state.breadcrumb.map((element, index, array) => {

                          const label: string = element.label.charAt(0).toUpperCase() + element.label.toLowerCase().slice(1);


                          return (
                            <BreadcrumbItem key={'breadcrumb' + index} active={index === array.length - 1}>
                                {
                                  element.url.includes('http')?
                                    <a href={element.url}>{label}</a>
                                    :
                                    <Link to={element.url}>{label}</Link>
                                }
                                {(index !== array.length - 1) && (<span className='separator'>/</span>)}
                              </BreadcrumbItem>
                          )
                        })
                      )
                      }
                    </Breadcrumb>

                    {(this.state.context?.confEnte.external_footer != null && 
                      this.state.context?.confEnte.external_footer != '' &&
                      this.state.context?.confEnte.external_header != null &&
                      this.state.context?.confEnte.external_header != '' &&
                      this.state.context?.userLogged &&
                      this.state.context?.tabMenuAutenticatoVisibile
                      ) &&
                      <TabMenu baseUrl= {this.state.context.confEnte.base_url} 
                        headerLinks={this.state.context.confEnte.header_links}
                        navigazioneReact={this.state.context.confEnte.navigazione_react}
                        className='my-5'></TabMenu>
                    }
                  </Col>
                </Row>
                <React.Suspense fallback={<span>Loading...</span>}>
                  <FlashAlert flash={this.state.flash != null ? this.state.flash : null} />
                </React.Suspense>
                {/* <Row className='mb-3'>
                  <Col>
                    {this.state.routes.length == 0 && (
                      <span>Caricamento...</span>
                    )}
                  </Col>
                </Row> */}
                <Row className='mb-3' id="corpo_centrale">
                  {this.state.context?.confEnte && (
                  <Col>
                    
                      <div id="contenuto_dinamico">
                        {/* usato per navigazione react https://v5.reactrouter.com/web/example/route-config */}
                        <ErrorBoundary>
                          <Routes>

                            <Route path="/portal/autenticazione" element={
                              <React.Suspense fallback={<span>Loading...</span>}>
                                <Autenticazione updateBreadcrumb={this.handleUpdateBreadcrumb} updateLoader={this.handleUpdateLoader} apiClient={this.apiClient} setContext={this.setNewContext}></Autenticazione>
                              </React.Suspense>
                            } />


                            {this.state.routes.map((route, i) => (
                              route.protected ?

                                <Route key={'route' + i} path={route.path}
                                  element={
                                    <this.ProtectedRoute userLogged={this.state.context.userLogged} path={route.path}>
                                      <React.Suspense fallback={<span>Loading...</span>}>
                                        <route.component updateBreadcrumb={this.handleUpdateBreadcrumb} updateLoader={this.handleUpdateLoader} apiClient={this.apiClient} setContext={this.setNewContext}></route.component>
                                      </React.Suspense>
                                    </this.ProtectedRoute>
                                  }
                                />
                                :
                                <Route key={'route' + i} path={route.path}
                                  element={
                                    <React.Suspense fallback={<span>Loading...</span>}>
                                      <route.component updateBreadcrumb={this.handleUpdateBreadcrumb} updateLoader={this.handleUpdateLoader} apiClient={this.apiClient} setContext={this.setNewContext}></route.component>
                                    </React.Suspense>
                                  } />
                            )
                            )}

                          </Routes>
                        </ErrorBoundary>
                      </div>     
                  </Col>
                  )}
                </Row>
              </Container>
              {(this.state.context?.confEnte) && this.state.elemChanged &&  (
                <>
                  { this.state.context.confEnte.codice_fiscale && this.state.context.appCorrente && this.state.context.confEnte.abilito_feedback && (
                    <React.Suspense fallback={<span>Loading...</span>}>
                      <div id="feedback_box">  
                        <Feedback parametri={
                            {
                              clientID: '',
                              codiceFiscaleEnte: this.state.context.confEnte.codice_fiscale,
                              dominioEnte: this.state.context.confEnte.domain,
                              servizio: this.state.context.appCorrente,
                              tipologiaServizio: this.state.context.tipologiaServizio,
                              urlInvioFeedback: this.state.context.confEnte.url_app_feedback
                            }
                          } tipoPagina={(this.state.context.appCorrente === 'Portal' ||
                        this.state.context.appCorrente === 'Comunicazioni') ? 'informativa' : 'servizio'}
                        key={document.location.pathname}></Feedback>
                      </div>
                    </React.Suspense>
                    )  
                  }
                  <ErrorBoundary>
                    <React.Suspense fallback={<span>Loading...</span>}>
                      <BoxGuideTecniche updateLoader={this.handleUpdateLoader} apiClient={this.apiClient}/>
                    </React.Suspense>
                  </ErrorBoundary>
                  
                  {(this.state.context?.confEnte.external_footer != null && 
                      this.state.context?.confEnte.external_footer != '' &&
                      this.state.context?.confEnte.external_header != null &&
                      this.state.context?.confEnte.external_header != ''
                      )?
                    (<IntegrationFooter urlFetch={this.state.context.confEnte.external_footer}/>)
                    :
                    (<Footer
                      nomeEnte={this.state.context.confEnte.titolo_header}
                      logoEnte={this.state.context.confEnte.stemma ?? ''}
                      logoUE={this.state.context.confEnte.logo_eu ?? ''}
                      logoDeda={this.state.context.confEnte.logo_deda ?? ''}
                      cellulare={this.state.context.confEnte.cellulare}
                      iban={this.state.context.confEnte.iban}
                      indirizzo={this.state.context.confEnte.indirizzo}
                      linkAccessibilita={this.state.context.confEnte.link_accessibilita}
                      linkAppuntamenti={this.state.context.confEnte.link_appuntamenti}
                      linkNoteLegali={this.state.context.confEnte.link_note_legali}
                      linkGdpr={this.state.context.confEnte.link_gdpr}
                      sezServizi = {this.state.context.confEnte.ft_sez_servizi}
                      sezAContatti = {this.state.context.confEnte.ft_sez_a_contatti}
                      sezBContatti = {this.state.context.confEnte.ft_sez_b_contatti}
                      sezPoweredBy = {this.state.context.confEnte.ft_sez_poweredby}
                      sezImmagine = {this.state.context.confEnte.ft_sez_immagine}
                      partitaIva={this.state.context.confEnte.partita_iva}
                      pec={this.state.context.confEnte.pec}
                      telefono={this.state.context.confEnte.telefono}
                      linkUrp = {this.state.context.confEnte.link_urp}
                      numeroVerde = {this.state.context.confEnte.numero_verde}
                      navigazioneReact = {this.state.context.confEnte.navigazione_react}
                      baseUrl = {this.state.context.confEnte.base_url}
                      footerLinks = {this.state.context.confEnte.header_links}
                      className='w-100'
                    />)}
                  
                </>
              )}
              <Loader centered fade={false} text=''
                isOpen={this.state.loader.visible}
                onOpened={() => {
                  document.body.style.overflow = "hidden"
                }}
                onClosed={() => {
                  document.body.classList.remove("modal-open");
                  document.body.style.overflow = "visible"
                }}
              />
            </ScrollTopWrapper>
          </Router>
        </AppProvider>
      </React.Fragment>
    )

  }


}


const root = createRoot(document.getElementById('portal_container')!);
root.render(
  <App />
);

